import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import Select from "react-select";
import { COLORS } from "../../utils/colors";

const customStyles = {
  menu: (provided) => ({
    ...provided,
    width: 250,
    zIndex: 2,
  }),
};

const getOptionLabel = (option) => {
  const availableColor = option?.value;
  return (
    availableColor && (
      <div className="d-flex align-items-center">
        <div
          style={{
            backgroundColor: availableColor.hex,
            minWidth: "15px",
            height: "15px",
            border: "1px solid",
            display: "inline-block",
            marginRight: "4px",
          }}
        />
        <div>{availableColor.title}</div>
        <div>
          <em className="small text-muted">
            {availableColor.RAL} {availableColor.HKS}
          </em>
        </div>
      </div>
    )
  );
};

const getOptionValue = (option) => option?.value?.title || "";

const ColorSelectForHookForm = forwardRef(
  ({ value, onChange, onBlur, materialSerie }, ref) => {
    // Dynamically generate options based on materialSerie
    const options =
      COLORS[materialSerie]?.map((availableColor) => ({
        value: availableColor, // Full color object
        label: availableColor.title, // Label for dropdown
      })) || [];

    // Ensure value matches an object from options
    const selectedOption = options.find(
      (option) => option.value.title === value.title
    );

    return (
      <Select
        ref={ref}
        value={selectedOption || null} // Match value to an option
        onChange={(selectedOption) => onChange(selectedOption?.value || null)} // Update form state
        onBlur={onBlur}
        options={options}
        getOptionLabel={getOptionLabel}
        getOptionValue={getOptionValue}
        styles={customStyles}
        isSearchable
      />
    );
  }
);

ColorSelectForHookForm.propTypes = {
  value: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  materialSerie: PropTypes.number.isRequired,
};

export default ColorSelectForHookForm;
